import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, of } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { API_BASE_URL } from './env.service';
import { ObjectType } from 'src/shared/models/object.model';

export interface DiscoveryMetadata {
  name: string;
  description: string;
  type: string;
  address: string;
  units: string;
  pointId?: string;
}

export interface TileMetadata {
  ObjectID: string;
  ObjectType: string;
  Permanent?: {
    discovery?: DiscoveryMetadata;
    [key: string]: any;
  };
  Custom?: Record<string, any>;
}

export interface PermanentMetadata {
  discovery?: DiscoveryMetadata;
  [key: string]: any;
}

@Injectable({
  providedIn: 'root'
})
export class MetadataService {
  private readonly baseUrl = `${API_BASE_URL}/metadata`;

  constructor(private http: HttpClient) {}

  getMetadata$(objectId: string, objectType = ObjectType.TILE): Observable<TileMetadata | null> {
    // PLAT-266: Return null for mock canvas tile
    if (objectId === 'mock-canvas-tile-id') {
      return of(null);
    }

    return this.http.get<TileMetadata | null>(this.baseUrl, {
      params: { ObjectID: objectId, ObjectType: objectType }
    }).pipe(
      retry(1),
      catchError(this.handleError)
    );
  }

  patchPermanentMetadata$(
    objectId: string,
    metadata: PermanentMetadata,
    objectType = ObjectType.TILE
  ): Observable<void> {
    return this.http.patch<void>(`${this.baseUrl}/permanent`, metadata, {
      params: { ObjectID: objectId, ObjectType: objectType }
    }).pipe(
      catchError(this.handleError)
    );
  }

  private handleError(error: HttpErrorResponse): Observable<never> {
    const errorMessage = error.error?.message || error.message || 'An unknown error occurred';
    console.error('Metadata service error:', errorMessage);
    return throwError(() => new Error(errorMessage));
  }
}
